import { JSX } from "solid-js";
import { useTelescopeContext } from "@hubble/telescope";
import { openModalV2, goBack } from "~/shared_states/modal";
import { toIndianNumber } from "~/utils/number";
import { coinIcon } from "~/assets/assets";
import { BorderGradientTelescope } from "~/components/border_gradient/border_gradient_telescope";
import { BRANDS_COUNT } from "~/data/partner_config";

export interface WelcomeMessageTelescopeProps {
  coinsCredited: number;
  userName: string;
  totalBalance: number;
  onClose?: () => void;
  singleBrandName?: string;
}

/**
 * Opens the Welcome Message Modal (Telescope version)
 * Shows when users receive new coins
 */
export const openCoinsCreditedMessageTelescope = (
  props: WelcomeMessageTelescopeProps
) => {
  openModalV2(() => <CoinsCreditedMessageTelescope {...props} />, {
    size: "small",
  });
};

/**
 * Welcome Message Modal Component (Telescope Design System)
 * Displays when users receive coin credits
 */
export function CoinsCreditedMessageTelescope(
  props: WelcomeMessageTelescopeProps
): JSX.Element {
  const { components } = useTelescopeContext();

  const handleClose = () => {
    goBack();
    props.onClose?.();
  };

  // Build personalized title
  const title = () => {
    if (props.userName) {
      return `Congratulations, ${props.userName}!`;
    }
    return "Congratulations!";
  };

  return (
    <>
      {/* Modal Header */}
      <components.ModalHeader
        size="large"
        icon={() => <img src={coinIcon} alt="Coin" class="h-[60px] w-[60px]" />}
        title={title()}
        description="Coins credited"
        onClose={handleClose}
      />

      {/* Content Section */}
      <div class="px-5 pb-5">
        {/* Amount Card with Golden Border */}
        <BorderGradientTelescope>
          <div class="flex w-full flex-col items-center justify-center gap-1.5 rounded-xl border-2 border-stroke-1 bg-background-normal-primary px-0 py-3">
            <div class="text-[32px] font-semibold leading-[40px] tracking-[-0.16px] text-text-normal-primary">
              +₹{toIndianNumber(props.coinsCredited)}
            </div>
            <div class="text-[12px] font-normal leading-4 tracking-[-0.12px] text-text-normal-secondary">
              Balance: ₹{toIndianNumber(props.totalBalance)}
            </div>
          </div>
        </BorderGradientTelescope>

        {/* Helper Text */}
        <div class="mt-4 text-center text-para-3-regular text-text-normal-secondary">
          {props.singleBrandName
            ? `Use coins to shop on ${props.singleBrandName}.`
            : `Use coins to shop on ${BRANDS_COUNT}+ brands.`}
        </div>
      </div>

      {/* Modal Footer */}
      <components.ModalFooter
        button={{
          text: "Awesome",
          onClick: handleClose,
          variant: "primary",
          style: "neutral",
          size: 40,
        }}
      />
    </>
  );
}
